import Product1 from '../../assets/images/product/product-1.jpg';
import Product2 from '../../assets/images/product/product-2.jpg'
import Product3 from '../../assets/images/product/product-3.jpg';
import Product4 from '../../assets/images/product/product-4.jpg';
import Product5 from '../../assets/images/product/product-5.jpg';
import Product6 from '../../assets/images/product/product-6.jpg';
import Product7 from '../../assets/images/product/product-7.jpg';
import Product8 from '../../assets/images/product/product-8.jpg'

export const ProductData = [
  {
    images: Product1,
    iconHeart: 'bi bi-heart-fill text-danger',
    iconStar: 'icofont-star text-warning',
    value: '4.5 (145)',
    title: 'Oculus VR',
    referenceTitle: 'Reference 1204',
    doller: '$ 149',
    button: 'Add to Cart',

  },
  {
    images: Product2,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: '3.5 (77)',
    title: 'Wall Clock ',
    referenceTitle: 'Reference 1004',
    doller: '$ 399',
    button: 'Add to Cart',

  },
  {
    images: Product3,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: '3.5 (98)',
    title: 'Note Diaries',
    referenceTitle: 'Reference 1224',
    doller: '$ 149',
    button: 'Add to Cart',

  },
  {
    images: Product4,
    iconHeart: 'bi bi-heart-fill text-danger',
    iconStar: 'icofont-star text-warning',
    value: '4.5 (1455)',
    title: 'Flower Port',
    referenceTitle: 'Reference 1414',
    doller: '$ 399',
    button: 'Add to Cart',

  },
  {
    images: Product5,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: '4.5 (145)',
    title: 'School Bag ',
    referenceTitle: 'Reference 1000',
    doller: '$ 149',
    button: 'Add to Cart',

  },
  {
    images: Product6,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: ' 4.5 (1245)',
    title: 'Rado Watch',
    referenceTitle: 'Reference 9204',
    doller: '$ 399',
    button: 'Add to Cart',

  },
  {
    images: Product7,
    iconHeart: 'bi bi-heart-fill text-danger',
    iconStar: 'icofont-star text-warning',
    value: ' 4.5 (1045)',
    title: 'Traveling Bag',
    referenceTitle: 'Reference 1155',
    doller: '$ 399',
    button: 'Add to Cart',

  },
  {
    images: Product8,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: ' 4.5 (77)',
    title: 'Wall Clock',
    referenceTitle: 'Reference 1004',
    doller: '$ 399',
    button: 'Add to Cart',

  },
  {
    images: Product3,
    iconHeart: 'bi bi-heart text-danger',
    iconStar: 'icofont-star text-warning',
    value: ' 4.5 (98)',
    title: 'Note Diaries',
    referenceTitle: 'Reference 1224',
    doller: '$ 149',
    button: 'Add to Cart',

  }
]